module.exports = __webpack_public_path__ + "static/media/icon-7.6ef3ca2f.svg";